import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import SectionHeading from "./sectionHeading";
import { SimpleTabs } from "./tabs";
import DataCards from "./dataCards";
import { useApi } from "../../hooks/useApi";
import moment from "moment";
import ArticleDataSection from "./articleDataSection";

const DataModule = ({ content }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const [dataCards, setDataCards] = useState({});

  const country = content.tabs[activeIndex].title;

  const covidUrl =
    country.toLowerCase() !== "world"
      ? `https://coronavirus-tracker-api.herokuapp.com/v2/locations?country=${country}`
      : "https://coronavirus-tracker-api.herokuapp.com/v2/locations";

  const covidInfor = useApi({
    url: covidUrl,
    type: "get"
  });

  const toggleTab = index => {
    setActiveIndex(index);
  };

  const buttonDetails = content.tabs.map(({ title }, index) => {
    return {
      text: title,
      classes: `secondary sm ${activeIndex === index ? "active" : ""}`
    };
  });

  const date = moment(Date(new Date().getTime() - 24 * 60 * 60 * 1000)).format("DD MMM YYYY");

  const createCardInfor = covidData => {
    return [
      {
        title: "CONFIRMED",
        data: covidData.latest.confirmed
      },
      {
        title: "DEATHS",
        data: covidData.latest.deaths
      },
      {
        title: "RECOVERED",
        data: covidData.latest.recovered
      }
    ];
  };

  useEffect(() => {
    if (covidInfor && covidInfor.latest) {
      const cardInfor = createCardInfor(covidInfor);
      setDataCards(cardInfor);
    }
  }, [covidInfor, activeIndex]);

  return (
    <div className="dataModule">
      <div className="intro">
        <div className="introTopContainer">
          <SectionHeading title={content.title} />
          <div className="date">{date}</div>
        </div>
        <SimpleTabs flexDirection="row" buttonDetails={buttonDetails} onClick={toggleTab} className="tabs" />
      </div>
      <div className="container">
        <DataCards groups={dataCards} activeIndex={activeIndex} />
        {content.articlesList && !isMobile ? <ArticleDataSection content={content.articlesList} /> : null}
      </div>
    </div>
  );
};

export default DataModule;
